import UniqueId from 'vue-unique-id';
import Vue from 'vue';

if (!Vue.prototype.$id) {
    Vue.use(UniqueId);
}
